// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {Proxy_type} from '../../../hola/pub/ui/pro/cp/orders';

const {SDC, DDC, SHARED_ISP, ISPPREM, RES, EV_ISP, EV_RES, SNK} = Proxy_type;

export const products = {
    [SDC]: 'Shared Datacenter',
    [DDC]: 'Dedicated Datacenter',
    [SHARED_ISP]: 'ISP',
    [ISPPREM]: 'ISP Premium',
    [RES]: 'Rotating Residential',
    [EV_ISP]: 'Events & E-commerce ISP',
    [EV_RES]: 'Events Tickets Residential',
    [SNK]: 'Sneakers Residential'
};

export const product_pages = {
    [SDC]: '/products/shared-datacenter-proxies',
    [DDC]: '/products/dedicated-datacenter-proxies',
    [SHARED_ISP]: '/products/isp-proxies',
    [ISPPREM]: '/products/isp-premium-proxies',
    [RES]: '/products/residential',
    [EV_ISP]: '/products/events-and-ecommerce-proxies',
    [EV_RES]: '/products/events-resi-tickets',
    [SNK]: '/products/resi-sneakers',
};

export const product_features = {
    1: 'SOCKS5 Support',
    2: 'Private IP',
    3: 'Unbeatable Pricing',
    4: 'Not Shared',
    5: '99.99% Uptime',
    6: 'No hidden fees',
    7: 'Massive IP pool',
    8: 'Static Residential IPs',
    9: '195 Countries',
    10: 'Instant Delivery',
    11: 'Premium Static Residential IPs',
    12: 'Unblock key websites',
    13: 'Search Engine Scraping',
    14: 'Top US proxies',
    15: 'Private IP (not shared)',
    16: 'True Residential IPs',
    17: 'Scrape any website',
    18: '10K IPs per Generation',
    19: 'Global Mobile IPs',
    20: 'Advanced Network Routing',
    21: 'Exclusive IP Pool',
    22: 'Ticket Master/AXS/Retail Sites',
    23: 'Unblocked Access',
    24: 'Access global events & products',
    25: 'Read-only proxies',
    26: 'Premium US ISP proxies',
    27: 'Unblocked access',
    28: 'Optimized for events & E-commerce sites',
    29: 'No KYC needed',
    30: 'Global IPs',
    31: 'Advanced network routing',
    32: 'Exclusive IPs pool',
    33: 'Quick identity verification process',
    34: 'Optimized for sneakers sites',
    35: 'Global residential proxies'
};

export const product_checks = {
    [SDC]: [1, 3, 6, 7],
    [DDC]: [1, 2, 3, 4],
    [SHARED_ISP]: [1, 8, 9, 10],
    [ISPPREM]: [11, 23, 13, 24],
    [RES]: [1, 9, 16, 17, 25],
    [EV_ISP]: [26, 27, 28, 29],
    [EV_RES]: [30, 31, 32, 33],
    [SNK]: [35, 23, 34, 29]
};

export const product_top_locations = ['us', 'gb', 'sg', 'ph', 'ru', 'cn',
    'tr', 'de', 'br', 'eg', 'in', 'nl'];
